var _a;
import { apiGenerator } from "../generic/all.api";
import CONFIG from "./invoiceItem.config";
export var getDetail = (_a = apiGenerator({
    resource: CONFIG.RESOURCE,
}), _a.getDetail), getPaged = _a.getPaged;
